import { Controller } from "@hotwired/stimulus"

// Moves a scheduled post to another day of the calendar by dragging it there.
// The server keeps the post's time of day, checks the person may move it and
// that the new day is allowed, and the page reloads to show where it landed.
export default class extends Controller {
  static values = { urlTemplate: String }

  start(event) {
    event.dataTransfer.setData("text/plain", event.currentTarget.dataset.postId)
    event.dataTransfer.effectAllowed = "move"
  }

  over(event) {
    if (!event.dataTransfer.types.includes("text/plain")) return
    event.preventDefault()
    event.currentTarget.classList.add("ring-2", "ring-primary-500")
  }

  leave(event) {
    event.currentTarget.classList.remove("ring-2", "ring-primary-500")
  }

  async drop(event) {
    event.preventDefault()
    const cell = event.currentTarget
    cell.classList.remove("ring-2", "ring-primary-500")
    const postId = event.dataTransfer.getData("text/plain")
    if (!postId) return

    const response = await fetch(this.urlTemplateValue.replace("__ID__", postId), {
      method: "PATCH",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": this.csrfToken },
      body: JSON.stringify({ date: cell.dataset.date })
    })
    if (!response.ok) {
      const body = await response.json().catch(() => ({}))
      window.alert(body.error || "The post could not be moved.")
      return
    }
    window.Turbo ? window.Turbo.visit(window.location.href, { action: "replace" }) : window.location.reload()
  }

  get csrfToken() {
    return document.querySelector("meta[name=csrf-token]")?.content
  }
}
